export default {
  price: {
    text: 'type.price',
    key: 'price',
  },
  stock: {
    text: 'type.stock',
    key: 'stock',
  },
  wrong_prod: {
    text: 'type.wrong_prod',
    key: 'wrong_product',
  },
  retailer_missing: {
    text: 'type.retailer_missing',
    key: 'store_price_missing',
  },
  error: {
    text: 'type.error',
    key: 'other',
  },
  suggestion: {
    text: 'type.suggestion',
    key: 'other',
  },
};
